var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95996 19.9697C6.78625 19.0455 7.79451 18.302 8.92163 17.7857C10.0488 17.2695 11.2702 16.9917 12.5098 16.9697C13.6922 16.9853 14.8597 17.2355 15.9446 17.7058C17.0295 18.1762 18.0103 18.8573 18.8298 19.7097",
    stroke: "#C5C5C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z",
    stroke: "#C5C5C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5099 9C15.5099 8.20435 15.1938 7.44129 14.6312 6.87868C14.0686 6.31607 13.3055 6 12.5099 6C11.7142 6 10.9512 6.31607 10.3885 6.87868C9.82594 7.44129 9.50989 8.20435 9.50989 9V11C9.50989 11.7956 9.82594 12.5587 10.3885 13.1213C10.9512 13.6839 11.7142 14 12.5099 14C13.3055 14 14.0686 13.6839 14.6312 13.1213C15.1938 12.5587 15.5099 11.7956 15.5099 11V9Z",
    stroke: "#C5C5C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGray);
export default __webpack_public_path__ + "static/media/profileGray.90e2e4baa679ceed0d88bd3ea616dcc3.svg";
export { ForwardRef as ReactComponent };